module.exports = __webpack_public_path__ + "static/img/MR1.941f4689.png";